<template>
  <div id="defaultId1" class="u20bb7 table_X u68g3Fw">
    <!-- 表格部分 -->
    <div id="g88e05" class="pb20">
      <div id="g2e713" class="u97906 mb10" v-if="tableData.length > 0">
        <!-- 标题 -->
        <div id="g9576c" class="u57fd1">
          <div class="flex_center">
            <div id="gd4d94" class="u5e22d detail_title_20">
              {{ $t("ContentTabs.Ownership") }}
            </div>

            <!-- <div
              class="margin-left20"
              v-if="activeIcon == 'computer1' && activeIcon3 == 'echarts'"
            >
              <el-button
                icon="el-icon-plus"
                style="
                  min-width: 32px !important;
                  width: 32px;
                  height: 32px;
                  min-height: 32px !important;
                "
                :disabled="level >= 3 || activeIcon3 == 'Owenrship'"
                @click="changeLevel('plus')"
              />
              <el-button
                icon="el-icon-minus"
                style="
                  min-width: 32px !important;
                  width: 32px;
                  height: 32px;
                  min-height: 32px !important;
                "
                :disabled="level <= 1 || activeIcon3 == 'Owenrship'"
                @click="changeLevel('minus')"
              />
            </div> -->
          </div>
          <div class="flex_center">
            <div id="ge4e89" class="u41151" v-if="activeIcon == 'computer1'">
              <div
                id="g66b8c"
                @click="activeIcon3 = 'Owenrship'"
                :style="
                  activeIcon3 == 'Owenrship'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="u72482"
              >
                <svg
                  t="1750843688729"
                  style="transform: rotateX(180deg)"
                  class="icon hidIcon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10223"
                  width="26px"
                  height="26px"
                >
                  <path
                    d="M976.384 688.64h-73.728V512c0-29.184-21.504-52.736-47.616-52.736h-316.416V335.36h73.728c26.112 0 47.616-23.552 47.616-52.736V52.736c0-29.184-21.504-52.736-47.616-52.736H411.136C385.024 0 363.52 23.552 363.52 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h73.728v123.904H168.448c-26.112 0-47.616 23.552-47.616 52.736v176.64H47.616c-26.112 0-47.616 23.552-47.616 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h202.24c26.112 0 47.616-23.552 47.616-52.736v-229.376c0-29.184-21.504-52.736-47.616-52.736H175.616v-169.472h309.248v169.472H411.136c-26.112 0-47.616 23.552-47.616 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h201.728c26.112 0 47.616-23.552 47.616-52.736v-229.376c0-29.184-21.504-52.736-47.616-52.736h-73.728v-169.472h309.248v169.472h-73.728c-26.112 0-47.616 23.552-47.616 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h202.24c26.112 0 47.616-23.552 47.616-52.736v-229.376c-0.512-28.672-22.016-52.224-48.128-52.224zM417.792 964.096v-215.552h187.904v215.552H417.792z m-363.52 0v-215.552h187.904v215.552H54.272zM606.208 59.904v215.552H417.792V59.904h188.416z m363.52 688.64v215.552h-187.904v-215.552h187.904z"
                    :fill="activeIcon3 == 'Owenrship' ? '#1290C9' : '#8497AB'"
                    p-id="10224"
                  ></path>
                </svg>
              </div>
              <div
                id="g8b81a"
                @click="activeIcon3 = 'echarts'"
                :style="
                  activeIcon3 == 'echarts'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="ub7903"
              >
                <svg
                  t="1750842149457"
                  class="icon hidIcon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="11525"
                  width="28px"
                  height="26px"
                >
                  <path
                    d="M896.00324 352c70.7 0 128-57.3 128-128 0-70.6-57.4-128-128-128-70.7 0-128 57.3-128 128 0 18.8 4.1 36.7 11.3 52.8 2.7 6 1.4 13.1-3.3 17.8l-24.2 24.2c-5.7 5.7-14.9 6.3-21.2 1.2-38.1-30.1-86.3-48-138.6-48-18.8 0-37.1 2.3-54.6 6.7-6.9 1.7-14.1-1.4-17.7-7.5l-6.6-11.4c-3.4-5.8-2.7-13.1 1.6-18.3 18.6-22.6 29.7-51.6 29.3-83.2C543.10324 89 486.30324 32.6 417.00324 32c-70.6-0.6-128.1 56.1-129 126.3-0.9 69.5 56.5 128.6 126 129.6 9.4 0.1 18.5-0.7 27.4-2.5 6.8-1.4 13.6 1.7 17.1 7.7l2.2 3.8c4 7 2.2 15.9-4.2 20.7-42.4 32.3-73 79.4-84 133.6-1.5 7.4-8.1 12.7-15.7 12.7h-94.1c-6.6 0-12.6-4-14.9-10.2-18.1-48-64.3-82.2-118.5-82.8C58.70324 370.3 0.50324 427.6 0.00324 498.1-0.49676 569.2 57.00324 627 128.00324 627c56.7 0 104.8-36.9 121.6-87.9 2.2-6.6 8.3-11.1 15.2-11.1h92c7.6 0 14.2 5.4 15.7 12.9 9.5 46.7 33.5 88 67 119.2 5.4 5 6.6 13.2 2.9 19.6l-21.7 37.6c-3.7 6.3-11.1 9.4-18.2 7.4-11.1-3.1-22.7-4.7-34.8-4.7-69.7 0.1-127 56.8-127.8 126.6-0.8 71.7 57.4 130 129.1 129.4 69.5-0.6 126.3-57.3 126.9-126.8 0.3-28-8.5-53.9-23.5-75.1-3.6-5.1-3.9-11.8-0.8-17.2l24.9-43.1c3.9-6.7 12-9.7 19.3-7 23.7 8.6 49.3 13.2 76 13.2 34.9 0 67.9-8 97.3-22.2 7.6-3.7 16.7-0.9 20.9 6.4l37 64c-26.3 23.5-43 57.7-43 95.8 0 70.9 58 128.5 128.9 128 69.7-0.5 126.2-56.7 127.1-126.3 0.9-70.1-57-129.3-127.1-129.7-6.2 0-12.3 0.4-18.3 1.2-6.5 0.9-12.8-2.2-16.1-7.8l-39.2-67.9c-3.4-5.9-2.7-13.3 1.7-18.4 34.2-39.3 54.9-90.7 54.9-147 0-38.9-9.9-75.5-27.4-107.4-3.4-6.2-2.2-13.9 2.8-18.9l28.4-28.4c4.9-4.9 12.4-6 18.7-2.9 17.4 8.6 36.9 13.5 57.6 13.5z m0-192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM128.00324 563c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m240 349c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m464-112c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM416.00324 224c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m289.1 385.1C674.90324 639.4 634.70324 656 592.00324 656s-82.9-16.6-113.1-46.9C448.60324 578.9 432.00324 538.7 432.00324 496s16.6-82.9 46.9-113.1C509.10324 352.6 549.30324 336 592.00324 336s82.9 16.6 113.1 46.9C735.40324 413.1 752.00324 453.3 752.00324 496s-16.6 82.9-46.9 113.1z"
                    p-id="11526"
                    :fill="activeIcon3 == 'echarts' ? '#1290C9' : '#8497AB'"
                  ></path>
                </svg>
              </div>
            </div>
            <div id="ge4e89" class="u41151 margin-left20">
              <div
                id="g8b81a"
                @click="activeIcon = 'table1'"
                :style="
                  activeIcon == 'table1'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="ub7903"
              >
                <svg
                  id="idex5xpV"
                  class="icon defaultIcon"
                  t="1718690711396"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4563"
                  width="32px"
                  height="28px"
                >
                  <path
                    id="id3aCJoQ"
                    d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                    :fill="activeIcon == 'table1' ? '#1290C9' : '#8497AB'"
                    p-id="4564"
                  ></path>
                </svg>
              </div>
              <div
                id="g66b8c"
                @click="powerEcharts(1)"
                :style="
                  activeIcon == 'computer1'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="u72482"
              >
                <svg
                  id="idNxDoHC"
                  class="icon defaultIcon"
                  t="1718690674036"
                  viewBox="0 0 1214 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4367"
                  width="32px"
                  height="28px"
                >
                  <path
                    id="idT6sPU1"
                    d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                    :fill="activeIcon == 'computer1' ? '#1290C9' : '#8497AB'"
                    p-id="4368"
                  ></path>
                  <path
                    id="iddq3HRE"
                    d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                    :fill="activeIcon == 'computer1' ? '#1290C9' : '#8497AB'"
                    p-id="4369"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <!-- 表格组件 -->
        <div id="g21ab2" class="uM2fl1R" v-if="activeIcon == 'table1'">
          <el-table
            id="idE7SscB"
            border
            class="uvnONjL table_font_size_14 ownTable"
            :data="tableData"
            empty-text="No Data"
          >
            <el-table-column
              id="idZNiLFn"
              prop="name"
              min-width="300"
              class-name="company company_link_tooltip_normal"
              :label="$t('Ownership.Name')"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  class="company_link"
                  v-if="
                    scope.row.id3a
                      .split('')
                      .every((char) => char >= '0' && char <= '9')
                  "
                  @click="setid(scope.row)"
                  style=""
                >
                  {{ scope.row.name }}
                </span>
                <span v-else class=" " style="">
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              id="idtwl2TQ"
              prop="country"
              :label="$t('Ownership.Country')"
              min-width="150"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="id7GjLfn"
              min-width="150"
              prop="location"
              class-name=" company_link_tooltip_normal"
              :label="$t('Ownership.Location')"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="idEZCIbe"
              prop="type"
              width="200"
              min-width="150"
              :label="$t('Ownership.Type')"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="idJkRfjh"
              prop="shares"
              :width="tableColumnWidth.colum5"
              min-width="130"
              :label="$t('Ownership.Shares') + ' (%)'"
              show-overflow-tooltip
              align="right"
            >
            </el-table-column>
            <el-table-column
              id="id9BIvlf"
              prop="relations"
              :width="tableColumnWidth.colum6"
              min-width="130"
              align="right"
              :label="$t('Ownership.Relation')"
              show-overflow-tooltip
            >
            <template slot-scope="scope">
              {{ scope.row.relations | FormatNum }}
            </template>
            </el-table-column>
          </el-table>
          <div id="caa693" class="  ">
            <div class="page_i_box">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>
              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                 <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total| FilterNum  }}&nbsp;</span>  results for "{{
                  $t("ContentTabs.Ownership")
                }}"
              </div>
            </div>
          </div>

          <!-- <div id="idciPJRI" class="uZgkgLm show_AllHeight" v-if="this.page.total > this.page.pageSize">
            <span id="g5e298" class="u144f9 show_All" @click="ShowAll()">Show More </span>
          </div> -->
        </div>

        <!-- 图部分 -->
        <div v-show="activeIcon == 'computer1'" class="echartsBtnspiv">
          <div id="g08e9f">
            <div
              class="flex_center_between_box"
              v-show="activeIcon3 == 'echarts'"
            >
              <ul class="table-ul">
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.UltimateBeneficiaryOwner")
                  }}</span>
                  <span class="ellipsis">{{
                    ShareholderChartSummaryObject?.ultimateBeneficiary | FilterNum
                  }}</span>
                </li>
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.ShareholderLevel")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.shareholdingLayers | FilterNum
                  }}</span>
                </li>
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.TotalPartiesInvolved")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.partiesInvolved | FilterNum
                  }}</span>
                </li>
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.RelatedCompany")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.relatedCompany | FilterNum
                  }}</span>
                </li>
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.CompanyShareholders")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.companyShareholders | FilterNum
                  }}</span>
                </li>
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.NGOShareholders")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.ngoShareholders | FilterNum
                  }}</span>
                </li>
                <li class="table-li">
                  <span class="table-li-title">{{
                    $t("Ownership.NaturalPersonShareholder")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.naturalPersonShareholder | FilterNum
                  }}</span>
                </li>
                <li class="table-li" style="border-bottom: 1px solid #ccc">
                  <span class="table-li-title">{{
                    $t("Ownership.SubjectInvestments")
                  }}</span>
                  <span>{{
                    ShareholderChartSummaryObject?.subjectInvestments | FilterNum
                  }}</span>
                </li>
              </ul>
              <div
                id="idsLwvVN"
                style="width: 70%"
                class="ulDmLg9"
                alt
                ref="trendChart"
              ></div>
              <div
                class="graph_controls"
                v-if="activeIcon == 'computer1' && activeIcon3 == 'echarts'"
              >
                <button
                  class="btn_control"
                  :disabled="level >= 3 || activeIcon3 == 'Owenrship'"
                  @click="changeLevel('plus')"
                >
                  <i class="iconfont icon-fangda" />
                </button>
                <button
                  class="btn_control"
                  :disabled="level <= 1 || activeIcon3 == 'Owenrship'"
                  @click="changeLevel('minus')"
                >
                  <i class="iconfont icon-suoxiao" />
                </button>
              </div>
            </div>
            <div
              v-show="activeIcon3 == 'Owenrship'"
              class="equity-d3 margin-top10"
            >
              <EquityD3
                v-if="activeIcon3 == 'Owenrship'"
                :chartData="chartData"
              ></EquityD3>
            </div>
          </div>
        </div>
      </div>
      <div id="cf7af3" class="u97906 uc1158" v-if="Investment.length > 0">
        <div class="gaosimohu"></div>
        <!-- 标题 -->
        <div id="cf69b3" class="u57fd1">
          <div class="flex_center">
            <div id="c9890d" class="u5e22d detail_title_20">
              {{ $t("Ownership.SubjectInvestments") }}
            </div>

            <!-- <div
              class="margin-left20"
              v-if="activeIcon2 == 'computer2' && activeIcon4 == 'echarts'"
            >
              <el-button
                icon="el-icon-plus"
                style="
                  min-width: 32px !important;
                  width: 32px;
                  height: 32px;
                  min-height: 32px !important;
                "
                :disabled="level2 >= 3 || activeIcon4 == 'Owenrship'"
                @click="changeLevel2('plus')"
              />
              <el-button
                icon="el-icon-minus"
                style="
                  min-width: 32px !important;
                  width: 32px;
                  height: 32px;
                  min-height: 32px !important;
                "
                :disabled="level2 <= 1 || activeIcon4 == 'Owenrship'"
                @click="changeLevel2('minus')"
              />
            </div> -->
          </div>

          <div class="flex_center">
            <div id="ge4e89" class="u41151" v-if="activeIcon2 == 'computer2'">
              <div
                id="g66b8c"
                @click="activeIcon4 = 'Owenrship'"
                :style="
                  activeIcon4 == 'Owenrship'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="u72482"
              >
                <svg
                  t="1750843688729"
                  class="icon hidIcon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10223"
                  width="26px"
                  height="26px"
                >
                  <path
                    d="M976.384 688.64h-73.728V512c0-29.184-21.504-52.736-47.616-52.736h-316.416V335.36h73.728c26.112 0 47.616-23.552 47.616-52.736V52.736c0-29.184-21.504-52.736-47.616-52.736H411.136C385.024 0 363.52 23.552 363.52 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h73.728v123.904H168.448c-26.112 0-47.616 23.552-47.616 52.736v176.64H47.616c-26.112 0-47.616 23.552-47.616 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h202.24c26.112 0 47.616-23.552 47.616-52.736v-229.376c0-29.184-21.504-52.736-47.616-52.736H175.616v-169.472h309.248v169.472H411.136c-26.112 0-47.616 23.552-47.616 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h201.728c26.112 0 47.616-23.552 47.616-52.736v-229.376c0-29.184-21.504-52.736-47.616-52.736h-73.728v-169.472h309.248v169.472h-73.728c-26.112 0-47.616 23.552-47.616 52.736v229.376c0 29.184 21.504 52.736 47.616 52.736h202.24c26.112 0 47.616-23.552 47.616-52.736v-229.376c-0.512-28.672-22.016-52.224-48.128-52.224zM417.792 964.096v-215.552h187.904v215.552H417.792z m-363.52 0v-215.552h187.904v215.552H54.272zM606.208 59.904v215.552H417.792V59.904h188.416z m363.52 688.64v215.552h-187.904v-215.552h187.904z"
                    :fill="activeIcon4 == 'Owenrship' ? '#1290C9' : '#8497AB'"
                    p-id="10224"
                  ></path>
                </svg>
              </div>
              <div
                id="g8b81a"
                @click="activeIcon4 = 'echarts'"
                :style="
                  activeIcon4 == 'echarts'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="ub7903"
              >
                <svg
                  t="1750842149457"
                  class="icon hidIcon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="11525"
                  width="26px"
                  height="26px"
                >
                  <path
                    d="M896.00324 352c70.7 0 128-57.3 128-128 0-70.6-57.4-128-128-128-70.7 0-128 57.3-128 128 0 18.8 4.1 36.7 11.3 52.8 2.7 6 1.4 13.1-3.3 17.8l-24.2 24.2c-5.7 5.7-14.9 6.3-21.2 1.2-38.1-30.1-86.3-48-138.6-48-18.8 0-37.1 2.3-54.6 6.7-6.9 1.7-14.1-1.4-17.7-7.5l-6.6-11.4c-3.4-5.8-2.7-13.1 1.6-18.3 18.6-22.6 29.7-51.6 29.3-83.2C543.10324 89 486.30324 32.6 417.00324 32c-70.6-0.6-128.1 56.1-129 126.3-0.9 69.5 56.5 128.6 126 129.6 9.4 0.1 18.5-0.7 27.4-2.5 6.8-1.4 13.6 1.7 17.1 7.7l2.2 3.8c4 7 2.2 15.9-4.2 20.7-42.4 32.3-73 79.4-84 133.6-1.5 7.4-8.1 12.7-15.7 12.7h-94.1c-6.6 0-12.6-4-14.9-10.2-18.1-48-64.3-82.2-118.5-82.8C58.70324 370.3 0.50324 427.6 0.00324 498.1-0.49676 569.2 57.00324 627 128.00324 627c56.7 0 104.8-36.9 121.6-87.9 2.2-6.6 8.3-11.1 15.2-11.1h92c7.6 0 14.2 5.4 15.7 12.9 9.5 46.7 33.5 88 67 119.2 5.4 5 6.6 13.2 2.9 19.6l-21.7 37.6c-3.7 6.3-11.1 9.4-18.2 7.4-11.1-3.1-22.7-4.7-34.8-4.7-69.7 0.1-127 56.8-127.8 126.6-0.8 71.7 57.4 130 129.1 129.4 69.5-0.6 126.3-57.3 126.9-126.8 0.3-28-8.5-53.9-23.5-75.1-3.6-5.1-3.9-11.8-0.8-17.2l24.9-43.1c3.9-6.7 12-9.7 19.3-7 23.7 8.6 49.3 13.2 76 13.2 34.9 0 67.9-8 97.3-22.2 7.6-3.7 16.7-0.9 20.9 6.4l37 64c-26.3 23.5-43 57.7-43 95.8 0 70.9 58 128.5 128.9 128 69.7-0.5 126.2-56.7 127.1-126.3 0.9-70.1-57-129.3-127.1-129.7-6.2 0-12.3 0.4-18.3 1.2-6.5 0.9-12.8-2.2-16.1-7.8l-39.2-67.9c-3.4-5.9-2.7-13.3 1.7-18.4 34.2-39.3 54.9-90.7 54.9-147 0-38.9-9.9-75.5-27.4-107.4-3.4-6.2-2.2-13.9 2.8-18.9l28.4-28.4c4.9-4.9 12.4-6 18.7-2.9 17.4 8.6 36.9 13.5 57.6 13.5z m0-192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM128.00324 563c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m240 349c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m464-112c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM416.00324 224c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m289.1 385.1C674.90324 639.4 634.70324 656 592.00324 656s-82.9-16.6-113.1-46.9C448.60324 578.9 432.00324 538.7 432.00324 496s16.6-82.9 46.9-113.1C509.10324 352.6 549.30324 336 592.00324 336s82.9 16.6 113.1 46.9C735.40324 413.1 752.00324 453.3 752.00324 496s-16.6 82.9-46.9 113.1z"
                    p-id="11526"
                    :fill="activeIcon4 == 'echarts' ? '#1290C9' : '#8497AB'"
                  ></path>
                </svg>
              </div>
            </div>
            <div id="c4e07e" class="u41151 margin-left20">
              <div
                id="c3e402"
                @click="activeIcon2 = 'table2'"
                :style="
                  activeIcon2 == 'table2'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="ub7903"
              >
                <svg
                  id="c387dd"
                  class="icon u4W5d5U defaultIcon"
                  t="1718690711396"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4563"
                  width="32px"
                  height="28px"
                >
                  <path
                    id="ced621"
                    class="uQXRB13"
                    d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                    :fill="activeIcon2 == 'table2' ? '#1290C9' : '#8497AB'"
                    p-id="4564"
                  ></path>
                </svg>
              </div>
              <div
                id="c0c20e"
                @click="powerEcharts(2)"
                :style="
                  activeIcon2 == 'computer2'
                    ? 'background-color:#fff;'
                    : 'background-color:#F5F5F5'
                "
                class="u72482"
              >
                <svg
                  id="c274da"
                  class="icon upE66RF defaultIcon"
                  t="1718690674036"
                  viewBox="0 0 1214 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4367"
                  width="32px"
                  height="28px"
                >
                  <path
                    id="c74f10"
                    class="uL7NCen"
                    d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                    :fill="activeIcon2 == 'computer2' ? '#1290C9' : '#8497AB'"
                    p-id="4368"
                  ></path>
                  <path
                    id="cd9211"
                    class="uRwnrTT"
                    d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                    :fill="activeIcon2 == 'computer2' ? '#1290C9' : '#8497AB'"
                    p-id="4369"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <!-- 表格组件 -->
        <div id="c612f3" class="uM2fl1R" v-if="activeIcon2 == 'table2'">
          <el-table
            id="c9929e"
            class="uvnONjL table_font_size_14 ownTable"
            :data="Investment"
          >
            <el-table-column
              id="c26738"
              prop="name"
              min-width="300"
              class-name="company company_link_tooltip_normal"
              :label="$t('Ownership.Name')"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.id3a == '-' || scope.row.type == 'Personal'"
                >
                  {{ scope.row.name }}
                </span>
                <span
                  v-else
                  class="company_link"
                  @click="setid(scope.row)"
                  style=""
                >
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              id="ce46f2"
              class="u5UTv34"
              prop="country"
              :label="$t('Ownership.Country')"
              min-width="150"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="cf573e"
              class="uU8BOPC"
              prop="location"
              :label="$t('Ownership.Location')"
              min-width="150"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              id="c82159"
              class="uTAgXFp"
              prop="type"
              :label="$t('Ownership.Type')"
              show-overflow-tooltip
              width="200"
              min-width="150"
            >
            </el-table-column>
            <el-table-column
              id="ca891b"
              class="uupj8Dl"
              prop="shares"
              :label="$t('Ownership.Shares') + ' (%)'"
              show-overflow-tooltip
              :width="tableColumnWidth.colum5"
              align="right"
            >
            </el-table-column>
            <el-table-column
              id="cc0cd9"
              class="uvTqQIk"
              prop="relations"
              align="right"
              :label="$t('Ownership.Relation')"
              show-overflow-tooltip
              :width="tableColumnWidth.colum6"
            >
            <template slot-scope="scope">
              {{ scope.row.relations | FormatNum }}
            </template>
            </el-table-column>
          </el-table>
          <div class="page_i_box">
            <Page
              :totalFont="true"
              :total="pageTwo.total"
              :pageSize.sync="pageTwo.pageSize"
              :currentPage="pageTwo.pageNo"
              @onPageChange="onPageChangeListTwo"
            ></Page>

            <div class="search_rsult_txt line_2">
              {{ pageTwo.pageNo }}-{{ pageTwo.pageSize }} of over
               <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ pageTwo.total | FilterNum }}&nbsp;</span>  results for "{{
                $t("Ownership.SubjectInvestments")
              }}"
            </div>
          </div>
          <!-- <div id="cf4490" class="uZgkgLm show_AllHeight" v-if="this.pageTwo.total > this.pageTwo.pageSize">
            <span id="c938f1" class="u144f9 ufuLtku show_All" @click="ShowAllTwo()">Show More </span>
          </div> -->
        </div>
        <!-- 图部分 -->
        <div v-show="activeIcon2 == 'computer2'" class="echartsBtnspiv">
          <div id="g08e9f">
            <div
              id="idsLwvVN"
              class="ulDmLg9"
              v-show="activeIcon4 == 'echarts'"
              alt
              ref="ownership2"
            ></div>
            <div
              class="graph_controls"
              v-if="activeIcon2 == 'computer2' && activeIcon4 == 'echarts'"
            >
              <button
                class="btn_control"
                :disabled="level2 >= 3 || activeIcon4 == 'Owenrship'"
                @click="changeLevel2('plus')"
              >
                <i class="iconfont icon-fangda" />
              </button>
              <button
                class="btn_control"
                :disabled="level2 <= 1 || activeIcon4 == 'Owenrship'"
                @click="changeLevel2('minus')"
              >
                <i class="iconfont icon-suoxiao" />
              </button>
            </div>
            <!-- <div class="hellotwo" id="dragTwo"  @mousewheel.prevent="changeCanvas($event,'flowContainerTwo')" @mousedown="mouseDrag($event,'flowContainerTwo')"
              @dragover="allowDrop($event,'flowContainerTwo')" @dragenter="dragEnter($event,'flowContainerTwo')" @mouseup="mouseUp($event,'flowContainerTwo')"
              @mousemove="mouseMovetwo($event,'flowContainerTwo')" v-show="activeIcon4 == 'Owenrship'">
              <div class="org_tree_div" ref="flowContainerTwo" id="flowContainerTwo">
                <vue2-org-tree :data="orgdataTwo" :horizontal="false" :label-class-name="labelClassName" collapsable
                  @on-expand="onExpand" @on-node-click="NodeClick" :renderContent="renderContent" />
              </div>
            </div> -->
            <div
              v-show="activeIcon4 == 'Owenrship'"
              class="equity-d3 margin-top10"
            >
              <EquityD3Two
                v-if="activeIcon4 == 'Owenrship'"
                :chartData="chartDataTwo"
              ></EquityD3Two>
            </div>
          </div>
        </div>
      </div>
      <!-- <PermissionDialog></PermissionDialog> -->
      <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    </div>
  </div>

  <!--srcviewscompanydetailsBackgroundOwnershipvuehtmlEnd-->
</template>

<script>
import {
  getOwnership,
  getCompanyInvestment,
  getShareholderSummary,
  getCompanyCharttwo,
  getCompanyDetailchirt,
  getCompanyInvestmentChart,
  getPartPrivilege,
  getShareholderChartSummary,
} from "@/api/companyApi";
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import EquityD3 from "./componet/index.vue";
import EquityD3Two from "./componet/investments.vue";
import Page from "@/components/page/index.vue";
// interfaceCode
//importStart

import {
  formatterTxt,
  formatterTxtTips,
  formatList,
  formatListMax50,
} from "./utils";
//importEnd
import { mixins1 } from "@/mixins/index";
export default {
  mixins: [mixins1],
  name: "",
  props: {
    // srcviewscompanydetailsBackgroundOwnershipvuePropsStart
    // srcviewscompanydetailsBackgroundOwnershipvuePropsEnd
  },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getShareholderSummaryList();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  mounted() {
    this.getOwnershiplist();
    this.getPartPrivilege();
    this.getInvestmentList();
    this.echartslist();
    this.echartslisttwo();
    this.getCompanyDetailchirtList();
    this.getShareholderChartSummaryList();
    window.addEventListener("resize", this.resizeFn);
    window.addEventListener("resize", this.handleChartResize);
    // defaultLoad
    // srcviewscompanydetailsBackgroundOwnershipvueMountedStart

    // srcviewscompanydetailsBackgroundOwnershipvueMountedEnd
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
    window.removeEventListener("resize", this.handleChartResize);
  },
  created() {
    this.getShareholderSummaryList();
  },
  components: {
    PermissionDialog,
    ReLogin,
    EquityD3,
    EquityD3Two,
    Page,
  },

  data() {
    return {
      chartData: null,
      labelClassName: "bg-color-orange",
      orgdata: {},
      orgdataTwo: {},
      currentUnit: "人",
      msg: "111",
      zoomNum: 1,
      disX: null,
      disY: null,
      mainX: null,
      mainY: null,
      ifDrag: false,

      tableColumnWidth: {
        colum1: 0,
        colum2: 220,
        colum3: 350,
        colum4: 200,
        colum5: 200,
        colum6: 200,
      },
      reLoginVis: false,

      aaid: "",
      echartsdate: [],
      powerArr: [],
      echartsdateTwo: [],
      level: 1,
      level1: 1,
      level2: 1,
      level3: 1,
      ownershipEchart: "",
      // ownershipEchart2
      ownershipEchart2: "",
      // maxMap
      maxMap: 2,
      // minMap
      minMap: 0.4,
      // activeIcon
      activeIcon: "table1",
      activeIcon3: "echarts",
      activeIcon4: "echarts",
      page: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      ShareholderChartSummaryObject: null,
      pageTwo: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      comIcon1: "image://" + require("@/assets/img/echarts/comIcon1.png"),
      comIcon2: "image://" + require("@/assets/img/echarts/WechatIMG31.png"),
      comIcon3: "image://" + require("@/assets/img/echarts/comIcon3.png"),
      comIcon4: "image://" + require("@/assets/img/echarts/comIcon4.png"),
      comIcon5: "image://" + require("@/assets/img/echarts/comIcon5.png"),
      // tableData
      tableData: [],
      Investment: [],
      // activeIcon2
      activeIcon2: "table2",
      chartDataTwo: null,
      // srcviewscompanydetailsBackgroundOwnershipvueDataEnd
    };
  },
  methods: {
    // 窗口缩放时让 ECharts 图随容器重新计算尺寸
    handleChartResize() {
      this.ownershipEchart?.resize();
      this.ownershipEchart2?.resize();
    },
    resizeFn() {
      if (document.body.clientWidth < 1440) {
        this.tableColumnWidth = {
          // 表格不支持rem单位，这块只能手动转rem为px

          colum5: 150,
          colum6: 150,
        };
      } else {
        this.tableColumnWidth = {
          // 表格不支持rem单位，这块只能手动转rem为px

          colum5: 200,
          colum6: 200,
        };
      }
    },
    getShareholderChartSummaryList() {
      getShareholderChartSummary({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.ShareholderChartSummaryObject = res.data;
        }
      });
    },
    getCompanyDetailchirtList() {
      getCompanyDetailchirt({
        id3a: this.$route.query.id3a,
        page: "1",
        pageSize: "50",
      }).then((Res) => {
        if (Res.code == 200) {
          let ecahrtsdata = Res.data;
          // ecahrtsdata = JSON.parse(
          //   JSON.stringify(ecahrtsdata).replace(/code/g, "aaa_id")
          // );
          //  ecahrtsdata = JSON.parse(
          //   JSON.stringify(ecahrtsdata).replace(/countryCode/g, "countrycode")
          // );
          ecahrtsdata = JSON.parse(
            JSON.stringify(ecahrtsdata).replace(/name/g, "entname"),
          );
          ecahrtsdata = JSON.parse(
            JSON.stringify(ecahrtsdata).replace(/entnameNative/g, "entnameen"),
          );
          //    ecahrtsdata = JSON.parse(
          //   JSON.stringify(ecahrtsdata).replace(/shareholders/g, "parents")
          // );
          //    ecahrtsdata = JSON.parse(
          //   JSON.stringify(ecahrtsdata).replace(/entinvs/g, "children")
          // );
          this.chartData = ecahrtsdata;
          this.chartData = JSON.parse(
            JSON.stringify(this.chartData).replace(/shareholders/g, "parents"),
          );
          this.chartDataTwo = ecahrtsdata;
          this.chartDataTwo = JSON.parse(
            JSON.stringify(this.chartDataTwo).replace(/entinvs/g, "children"),
          );
        }
      });
    },
    allowDrop(evt) {
      this.preventDefault(evt);
    },
    dragEnter(evt) {
      this.preventDefault(evt);
    },
    //阻止冒泡以及默认事件
    preventDefault(ev) {
      var evt = ev || window.event;
      if (typeof evt.preventDefault == "function") {
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }
      if (typeof evt.stopPropagation == "function") {
        evt.stopPropagation();
      } else {
        evt.cancelBubble = true;
      }
    },

    mouseDrag(e, value) {
      this.linemove = false;
      // console.log(e)
      let _this = this;
      this.ifDrag = true;
      let pos = _this.getPos(e); //获取鼠标坐标
      _this.disX = pos.x;
      _this.disY = pos.y;
      _this.mainX = _this.$refs[value].offsetLeft;
      _this.mainY = _this.$refs[value].offsetTop;
      if (value == "flowContainerTwo") {
        document.onmousemove = (event) => this.mouseMovetwo(event, value);
      } else {
        document.onmousemove = (event) => this.mouseMove(event, value);
      }
      document.onmouseup = (event) => this.mouseUp(event);
      // if (this.ifDrag) {
      //   this.mouseMove(e);
      // }
    },
    mouseMove(e, value) {
      var _this = this;

      if (!this.ifDrag) {
        return;
      }
      // xin
      const pos = this.getPos(e);
      const deltaX = pos.x - this.disX;
      const deltaY = pos.y - this.disY;

      const el = this.$refs[value];
      el.style.left = this.mainX + deltaX + "px";
      el.style.top = this.mainY - deltaY + "px";
      // 旧
      // var evt = window.event || e;
      // var left = evt.clientX - _this.disY + _this.mainY;
      // var top = evt.clientY - _this.disY + _this.mainY;
      // _this.$refs[value].style.left = left + "px";
      // _this.$refs[value].style.top = -top + "px";
    },
    mouseMovetwo(e, value) {
      if (!this.ifDrag) {
        return;
      }
      // xin
      const pos = this.getPos(e);
      const deltaX = pos.x - this.disX;
      const deltaY = pos.y - this.disY;

      const el = this.$refs[value];
      el.style.left = this.mainX + deltaX + "px";
      el.style.top = this.mainY + deltaY + "px";
    },
    // this.mouseUp();

    mouseUp() {
      var _this = this;
      this.ifDrag = false;
      //鼠标抬起
      document.onmousemove = null;
      document.onmouseup = null;
    },
    // 获取位置
    getPos(ev) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let scrollLeft =
        document.documentElement.scrollLeft || document.body.scrollLeft;
      return { x: ev.clientX + scrollLeft, y: ev.clientY + scrollTop };
    },
    // 改变画布大小--通过鼠标滚轮 缩小，放大
    changeCanvas(event, value) {
      var delta = 0;
      var canvasDom = document.getElementById(value);
      var p = ["webkit", "moz", "ms", "o"];
      if (!event) event = window.event;
      if (event.wheelDelta) {
        //IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
        delta = event.wheelDelta / 120;
        if (window.opera) delta = -delta; //因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
      } else if (event.detail) {
        //FF浏览器使用的是detail,其值为“正负3”
        delta = -event.detail / 3;
      }
      if (delta > 0) {
        // 向上滚
        if (this.zoomNum < 2) {
          this.zoomNum += 0.1;
        }
      } else if (delta < 0) {
        // 向下滚
        if (this.zoomNum > 0.2) {
          this.zoomNum -= 0.1;
        }
      }
      for (var i = 0; i < p.length; i++) {
        canvasDom.style[p[i] + "Transform"] = "scale(" + this.zoomNum + ")";
      }
      canvasDom.style["transform"] = "scale(" + this.zoomNum + ")";
      return false;
    },

    renderContent(h, data) {
      return (
        <div>
          {data.type != 2 ? (
            <div class="content_div">
              <el-popover placement="right" trigger="hover">
                <div class="flex_center_start_box">
                  <span class="Companyicon flex_center">C</span>
                  <div>
                    <div class="title Twoline">{data.name}</div>
                    <div class=" flex_center_star">
                      {data.legalStatus == "Active" ? (
                        <span class="activeOwen">{data.legalStatus}</span>
                      ) : (
                        <span class="activeOwen activeOwenRed">
                          {data.legalStatus}
                        </span>
                      )}
                      <div class=" flex_wrap">
                        <span class="margin-left20">
                          Country :{this.getCountry(data.countryCode)}
                        </span>
                        <span class="margin-left20">{data.companyType}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="reference">
                  <div class="title Twoline">{data.name}</div>
                  <div class="flex_center_bettwen Ownership_img">
                    {data.legalStatus == "Active" ? (
                      <span class="activeOwen">{data.legalStatus}</span>
                    ) : (
                      <span class="activeOwen activeOwenRed">
                        {data.legalStatus}
                      </span>
                    )}
                    <img
                      src={require("../../../../../static" +
                        this.getCountryImgUrl(data.countryCode))}
                      alt=""
                    />
                  </div>
                </div>
              </el-popover>
            </div>
          ) : (
            <div class="personName ">
              <div class="title Twoline">{data.name}</div>
              {/* 这里可以放其他内容 */}
            </div>
          )}
        </div>
      );
    },
    //点击节点
    NodeClick(e, data) {
      // console.log(e, data);
    },
    //默认展开
    toggleExpand(data, val) {
      var that = this;
      if (Array.isArray(data)) {
        data.forEach((item) => {
          that.$set(item, "expand", val);
          if (item.children) {
            that.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          that.toggleExpand(data.children, val);
        }
      }
    },
    collapse(list) {
      list.forEach((child) => {
        if (child.expand) {
          child.expand = false;
        }
        child.children && this.collapse(child.children);
      });
    },
    //展开
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data, "expand", true);
      }
    },

    powerEcharts(val) {
      if (this.powerArr[1]?.hasPrivilege) {
        if (val == 1) {
          this.showOwnershipEcahrt();
        } else {
          this.showOwnershipEcahrt2();
        }
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "405")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "406")[0];
      });
    },
    add(list) {
      list.forEach(async (item) => {
        if (!item.children.length) {
          if (item.code) {
            const params = {
              id3a: item.code,
              page: "1",
              pageSize: "5",
            };
            const res = await getCompanyCharttwo(params);
            let ecahrtsdata = res;
            ecahrtsdata = JSON.parse(
              JSON.stringify(ecahrtsdata).replace(/subsetList/g, "children"),
            );
            if (ecahrtsdata && ecahrtsdata.code) {
              this.loading = false;
              this.getList(
                this.echartsdate.children,
                item.code,
                ecahrtsdata?.data?.children,
              );
              this.setEchartList();
              this.$nextTick(() => this.showOwnershipEcahrt());
            } else {
            }
          }
        } else {
          this.add(item.children);
        }
      });
    },
    changeLevel(type) {
      if (type === "plus") {
        this.level++;
        this.level1++;
        this.level1 > 4 ? (this.level1 = 4) : this.level11;

        // 点加号按钮寻找当前数组的最外层children
        let that = this;
        if (this.level >= 2) {
          if (this.level1 < 4) {
            that.add(that.echartsdate.children);
          }
        }
      }

      if (type === "minus") this.level--;
      this.$nextTick(() => this.showOwnershipEcahrt());
    },
    // 递归获取数组
    getList(list, code, newVal) {
      list.forEach((item, index) => {
        if (list[index].code === code) {
          list[index].children = newVal;
        } else if (list[index].children && list[index].children.length > 0) {
          this.getList(list[index].children, code, newVal);
        }
      });
    },
    async echartslist() {
      const params = {
        id3a: this.$route.query.id3a,
        page: "1",
        pageSize: "10",
      };
      const res = await getCompanyCharttwo(params);
      const ecahrtsdata = res;
      if (ecahrtsdata && ecahrtsdata.code) {
        this.echartsdate = ecahrtsdata.data;

        this.orgdata = JSON.parse(
          JSON.stringify(this.echartsdate).replace(/subsetList/g, "children"),
        );

        this.toggleExpand(this.orgdata, true);
        this.setEchartList();
        // this.$nextTick(() => this.showOwnershipEcahrt());
      } else {
        this.loading = false;
      }
    },
    setEchartList(echartsdate = this.echartsdate) {
      const echartData = echartsdate.subsetList || []; // 股东list
      this.companyAaaid = this.echartsdate.code;
      const data = {
        name: this.echartsdate.name,
        nameEn: this.echartsdate.name,
        code: this.companyAaaid,
        companyType: this.echartsdate.companyType,
        countryCode: this.echartsdate.countryCode,
        type: this.echartsdate.type,
        legalStatus: this.echartsdate.legalStatus,
        children: [],
      };
      const childrenList = formatListMax50(
        echartData,
        this.companyAaaid,
        this.companyAaaid,
      );
      data.children = childrenList;
      if (childrenList && childrenList.length > 0) {
        this.getLevel2Children(data, this.companyAaaid);
      } else {
        this.echartData = data;
      }
    },

    getLevel2Children(vals = data, aaaid) {
      const echartData = vals;
      echartData.children.map((item, index) => {
        if (item.isMax == aaaid) {
          const echartData = item.subsetList || [];
          const subsetList = formatListMax50(
            echartData,
            this.companyAaaid,
            this.companyAaaid,
          );

          item.subsetList = subsetList;
        }
      });
      this.echartsdate = echartData;
    },
    getShareholderSummaryList() {
      getShareholderSummary({ id3a: this.$route.query.id3a }).then((res) => {
        if (res.code == 200) {
          let manManagementSummary = [
            {
              name: this.$t("Ownership.UltimateBeneficiaryOwner"),
              id: this.$t("Ownership.UltimateBeneficiaryOwner"),
              num: res.data.ultimateBeneficiary,
            },
            // {
            //   name: "Controlling Shareholder",
            //   id: "Controlling Shareholder",
            //   num: res.data.controllingCount,
            // },
            {
              name: this.$t("Ownership.TotalPartiesInvolved"),
              id: this.$t("Ownership.TotalPartiesInvolved"),
              num: res.data.participation,
            },
            {
              name: this.$t("Ownership.NaturalPersonShareholder"),
              id: this.$t("Ownership.NaturalPersonShareholder"),
              num: res.data.individualCount,
            },
            {
              name: this.$t("Ownership.InvolvingEnterprises"),
              id: this.$t("Ownership.InvolvingEnterprises"),
              num: res.data.enterpriseCount,
            },
            {
              name: this.$t("Ownership.ShareholderLevel"),
              id: this.$t("Ownership.ShareholderLevel"),
              num: res.data.penetrationDepth,
            },
          ];

          this.$emit("UpdatamarkTotalList", manManagementSummary);
        }
      });
    },
    onPageChangeListTwo({ page, size }) {
      this.pageTwo.pageNo = page;
      this.pageTwo.pageSize = size;
      this.getInvestmentList();
    },

    ShowAllTwo() {
      if (this.pageTwo.total > this.pageTwo.pageSize) {
        this.pageTwo.pageSize = this.pageTwo.pageSize + 10;
        this.getInvestmentList();
      }
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getOwnershiplist();
    },

    ShowAll() {
      if (this.page.total > this.page.pageSize) {
        this.page.pageSize = this.page.pageSize + 10;
        this.getOwnershiplist();
      }
    },

    getOwnershiplist() {
      const id3a = this.$route.query.id3a;
      getOwnership({
        id3a: id3a,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
        .then((Res) => {
          this.tableData = Res.data.rows;
          this.page.total = Res.data.total;
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    getInvestmentList() {
      const id3a = this.$route.query.id3a;
      getCompanyInvestment({
        id3a: id3a,
        page: this.pageTwo.pageNo,
        pageSize: this.pageTwo.pageSize,
      }).then((Res) => {
        this.Investment = Res.data.rows;
        this.pageTwo.total = Res.data.total;
      });
    },
    roamMap(flag, ownership) {
      const currentZoom = ownership.getOption().series[0].zoom;
      let increaseAmplitude = 1.2;

      if (flag === 1) {
        increaseAmplitude = 0.8;
      }

      ownership.setOption({
        series: [
          {
            zoom: currentZoom * increaseAmplitude,
          },
        ],
      });
    },
    async showOwnershipEcahrt() {
      this.activeIcon = "computer1";
      await this.$nextTick();

      if (!this.ownershipEchart) {
        // debugger;
        this.ownershipEchart = this.$echarts.init(this.$refs.trendChart);
        await this.$nextTick();
      }
      const that = this;
      let leval = that.level;
      const initialTreeDepth = leval;

      that.echartsdate = JSON.parse(
        JSON.stringify(that.echartsdate).replace(/subsetList/g, "children"),
      );
      let data = that.echartsdate;

      data.code = this.$route.query.id3a;
      const symbol = (data) => {
        if (`${data.invtypecode}` === "3") {
          // 外国公司
          return this.comIcon3;
        }
        if (`${data.invtypecode}` === "5") {
          // 国营企业
          return this.comIcon5;
        }

        if (`${data.code}` === this.$route.query.id3a) {
          return this.comIcon4;
        }
        if (data.type == "2") {
          // 个人
          return this.comIcon2;
        }
        return this.comIcon1;
      };
      const option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          fontSize: 12,
          formatter: (params) => formatterTxt(params),
        },
        series: [
          {
            type: "tree",
            data: [data],
            top: "4%",
            bottom: "14%",
            left: "2%",
            // roam: true,
            clickable: true,

            layout: "radial",
            symbol: (value, param) => symbol(param.data),
            symbolSize: 30,
            initialTreeDepth,
            animationDurationUpdate: 750,
            emphasis: {
              focus: "ancestor",
            },
            orient: "TB",
            label: {
              fontSize: 9,
              formatter: (params) => formatterTxt(params),
              rotate: 360,
            },
            leaves: {
              label: {
                fontSize: 9,
                formatter: (params) => formatterTxt(params),
                rotate: 360,
              },
            },
          },
        ],
      };

      this.ownershipEchart.setOption(option);
    },

    // Investment

    async showOwnershipEcahrt2() {
      this.activeIcon2 = "computer2";
      await this.$nextTick();

      if (!this.ownershipEchart2) {
        // debugger;
        this.ownershipEchart2 = this.$echarts.init(this.$refs.ownership2);
        await this.$nextTick();
      }
      const that = this;
      let leval = that.level2;
      const initialTreeDepth = leval;
      that.echartsdateTwo = JSON.parse(
        JSON.stringify(that.echartsdateTwo).replace(/subsetList/g, "children"),
      );
      // console.log('that.echartsdateTwo',that.echartsdateTwo);

      let data = that.echartsdateTwo;
      data.code = this.$route.query.id3a;
      const symbol = (data) => {
        if (`${data.invtypecode}` === "3") {
          // 外国公司
          return this.comIcon3;
        }
        if (`${data.invtypecode}` === "5") {
          // 国营企业
          return this.comIcon5;
        }

        if (`${data.code}` === this.$route.query.id3a) {
          return this.comIcon4;
        }
        if (data.type == "2") {
          // 个人
          return this.comIcon2;
        }
        return this.comIcon1;
      };
      const option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          fontSize: 12,
          formatter: (params) => formatterTxt(params),
        },
        series: [
          {
            type: "tree",
            data: [data],
            top: "18%",
            bottom: "14%",
            // roam: true,
            clickable: true,

            layout: "radial",
            symbol: (value, param) => symbol(param.data),
            symbolSize: 30,
            initialTreeDepth,
            animationDurationUpdate: 750,
            emphasis: {
              focus: "ancestor",
            },
            orient: "TB",
            label: {
              fontSize: 9,
              formatter: (params) => formatterTxt(params),
              rotate: 360,
            },
            leaves: {
              label: {
                fontSize: 9,
                formatter: (params) => formatterTxt(params),
                rotate: 360,
              },
            },
          },
        ],
      };

      this.ownershipEchart2.setOption(option);
    },
    async echartslisttwo() {
      const params = {
        id3a: this.$route.query.id3a,
        page: "1",
        pageSize: "10",
      };
      const res = await getCompanyInvestmentChart(params);
      const ecahrtsdata = res;
      if (ecahrtsdata) {
        this.echartsdateTwo = ecahrtsdata.data;

        this.setEchartListtwo();
        // this.showOwnershipEcahrt2()
        // this.$nextTick(() => this.showOwnershipEcahrt2());
      } else {
        this.loading = false;
      }
    },

    setEchartListtwo(echartsdate = this.echartsdateTwo) {
      const echartData = echartsdate.subsetList || []; // 股东list
      this.companyAaaid = this.echartsdateTwo.code;

      const data = {
        name: this.echartsdateTwo.name,
        nameEn: this.echartsdateTwo.nameEn,
        code: this.echartsdateTwo.code,
        companyType: this.echartsdateTwo.companyType,
        countryCode: this.echartsdateTwo.countryCode,
        type: this.echartsdateTwo.type,
        legalStatus: this.echartsdateTwo.legalStatus,
        children: [],
      };

      const childrenList = formatListMax50(
        echartData,
        this.companyAaaid,
        this.companyAaaid,
      );

      data.children = childrenList;
      if (childrenList && childrenList.length > 0) {
        this.getLevel2ChildrenTwo(data, this.companyAaaid);
      } else {
        this.echartDataTwo = data;
      }
    },

    getLevel2ChildrenTwo(vals = data, aaaid) {
      const echartData = vals;

      echartData.children.map((item, index) => {
        if (item.isMax == aaaid) {
          const echartData = item.subsetList || [];
          const subsetList = formatListMax50(
            echartData,
            this.companyAaaid,
            this.companyAaaid,
          );
          item.subsetList = subsetList;
        }
      });
      this.echartsdateTwo = echartData;
    },
    changeLevel2(type) {
      if (type === "plus") {
        this.level2++;
        this.level3++;
        this.level3 > 4 ? (this.level3 = 4) : this.level11;
        // 点加号按钮寻找当前数组的最外层children
        let that = this;
        if (this.level2 >= 2) {
          if (this.level3 < 4) {
            that.add2(that.echartsdateTwo.children);
          }
        }
      }

      if (type === "minus") this.level2--;
      this.$nextTick(() => this.showOwnershipEcahrt2());
    },
    add2(list) {
      list.forEach(async (item) => {
        console.log(item);

        if (!item.children?.length) {
          if (item.code) {
            const params = {
              id3a: item.code,
              page: "1",
              pageSize: "5",
            };
            const res = await getCompanyInvestmentChart(params);
            let ecahrtsdata = res;
            ecahrtsdata = JSON.parse(
              JSON.stringify(ecahrtsdata).replace(/subsetList/g, "children"),
            );

            if (ecahrtsdata && ecahrtsdata.code) {
              this.loading = false;
              this.getList(
                this.echartsdateTwo.children,
                item.code,
                ecahrtsdata?.data?.children,
              );
              this.setEchartListtwo();
              this.$nextTick(() => this.showOwnershipEcahrt2());
            } else {
            }
          }
        } else {
          this.add2(item.children);
        }
      });
    },
    setid(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.id3a +
          "/background/snapshot?id3a=" +
          row.id3a +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    //
  },
  computed: {},
};
</script>
<style>
.u97906 {
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
}

.u57fd1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 30px;
}

.u5e22d {
  font-size: 26px;
  line-height: 27px;
  color: #1290c9;
  font-family: "Arial Bold";
}

.u41151 {
  display: flex;
  width: 10rem;
  border-radius: 1.7857142857142858rem;
  background: #f5f5f5;
  padding: 0.21428571428571427rem;
}

.ub7903 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 3.142857142857143rem;
  border-radius: 1.5714285714285714rem;
}

.u72482 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 3.142857142857143rem;
  border-radius: 1.5714285714285714rem;
}

.uM2fl1R {
  margin-left: 40px;
  margin-top: 20px;
  margin-right: 40px;
}

.uvnONjL {
  background-color: #f5f5f5;
}

.u144f9 {
  font-size: 1.4285714285714286rem;
}

.echartsBtns {
  position: absolute;
  top: 2.142857142857143rem;
  left: 2.142857142857143rem;
  display: flex;
  flex-direction: column;
  z-index: 999999;
}

.uXdHX63 {
  display: flex;
  justify-content: center;
  /* position:relative;
}
		.u1fb61{/* left:3.5714285714285716em; */
  /* position:absolute; 
        top;*/
}

.u13926 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.2857142857142856rem;
  height: 2.2857142857142856rem;
  margin-left: 2.857142857142857rem;
  box-shadow: 0rem 0rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.1);
  border-radius: 0.2857142857142857rem;
}

.u95696 {
  margin-left: 2.857142857142857rem;
  margin-top: 0.7142857142857143rem;
}

.u44WfUA {
  width: 0;
  height: 56.857142857142854rem;
  flex: auto;
}

.u702a4 {
  width: 2.5rem;
  height: 2.5rem;
}

.ulDmLg9 {
  height: 796px;
  padding-top: 30px;
}

.uqxpbOh:hover {
  cursor: pointer;
}

.u2XrWW1:hover {
  cursor: pointer;
}

.u702a4:hover {
  cursor: pointer;
}

.uManXh9:hover {
  cursor: pointer;
}

.trendEchartBox1 {
  width: 85.71428571428571rem;
  height: 44.57142857142857rem;
}

.srcviewscompanydetailsBackgroundOwnershipvuecssEnd {
}

.echartsBtnspiv {
  position: relative;
  overflow: hidden;
}

.gaosimohu {
  filter: blur(0.35714285714285715em);
  background: #cccccc;
  opacity: 0.3;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 99999999;
  display: none;
}

#cf7af3 {
  /* filter: blur(0.35714285714285715em); */
  position: relative;
  /* display: none; */
}

.el-table::before {
  background-color: transparent !important;
}

.u68g3Fw .el-table__row td:nth-child(5),
.u68g3Fw .has-gutter th:nth-child(5) {
  /* padding-right: 2.857142857142857rem !important; */
}

.echartsBtns .el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
  margin-top: 0.7142857142857143rem;
}

.el-button:focus,
.el-button:hover {
  color: #1290c9;
  border: none;
  background: #ffffff;
}

.el-button {
  width: 2.2857142857142856rem;
  height: 2.2857142857142856rem;
  padding: 0;
  background: #ffffff;
  border: none;
  box-shadow: 0rem 0rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.1);
  border-radius: 0.2857142857142857rem;
}

.el-icon-plus {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
}

.el-icon-minus {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
}

.el-button:focus .el-icon-plus,
.el-button:hover .el-icon-plus,
.el-button:focus .el-icon-minus,
.el-button:hover .el-icon-minus {
  color: #1290c9;
}

.el-button.is-disabled:focus .el-icon-plus,
.el-button.is-disabled:hover .el-icon-plus,
.el-button.is-disabled:focus .el-icon-minus,
.el-button.is-disabled:hover .el-icon-minus {
  color: #1a2332;
}

.hello {
  width: 100%;
  /* height: 100vh; */
}

.org_tree_div {
  width: 100%;
  height: 100%;
}

/deep/ .org_tree_content {
  width: 100%;
  height: calc(100vh - 280px);
  overflow: auto;
}

.org_tree_div {
  display: inline-block;
  min-width: 100%;
  min-height: calc(100vh - 280px);
  display: flex;
  justify-content: center;
}

/deep/ .org_tree_content {
  width: 100%;
  height: calc(100vh - 280px);
  overflow: auto;
}

.org-tree-node-label-inner {
  height: 100%;
  position: relative;
  padding: 0px !important;
  font-size: 1.14285714rem;
}

.content_div {
  position: relative;
  height: 5.714286rem;
  width: 12.857rem;
  padding: 1rem 10px;
  font-size: 1.14285714rem;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.content_div:hover {
  cursor: pointer;
  border: 1px solid #016ff6;
  color: #016ff6 !important;
}

.org-tree-node-btn {
  background-color: #799eff;
  border: none;
}

.org-tree-node-btn:before {
  border-top: 1.5px solid #ffffff;
}

.org-tree-node-btn:after {
  border-left: 1.5px solid #ffffff;
}

.content_div .title {
  margin-top: 5px;
  color: #1a2332;
}

.Ownership_img {
  position: absolute;
  top: -15px;
  left: -0.5px;
  width: 101%;
  padding: 5px 0px;
  font-size: 1.14285714rem;
}

.Ownership_img img {
  height: 22px;
  width: 34px;
}

.activeOwen {
  background: #f3fff2;
  border-radius: 4px;
  border: 1px solid #3fb92f;
  padding: 0px 5px;
  color: #3fb92f;
  min-width: fit-content;
  max-height: 22px;
}

.activeOwenRed {
  background: #fff2f2;
  border: 1px solid #f56b6b;
  color: #f56b6b;
}

.personName {
  width: 5.714286rem;
  height: 5.714286rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #ff7600;
  padding: 5px;
}

.org-tree-node-label .org-tree-node-label-inner {
  box-shadow: none;
  -webkit-box-shadow: none;
}

.org-tree-node-children:before {
  height: 80px;
}

.org-tree-node-children,
.org-tree-node {
  padding-top: 80px;
}

.org-tree-node:after {
  padding-top: 60px;
}

.org-tree-node-btn {
  left: 51%;
}

.echartsBtnsTwo {
  left: 1.43rem;
  top: 10rem;
  height: 9rem;

  justify-content: space-between;
  width: 50px;
  align-items: center;
  border-radius: 1.7857142857142858rem;
  background: #f5f5f5;
  padding: 5px;
}

.echartsBtnsTwo-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  border-radius: 22px;
}

#drag,
#dragTwo {
  width: 100%;
  background: #fff;
  overflow: hidden;
}

.hello,
.hello .content_div,
.hello .personName {
  transform: rotateX(180deg) !important;
}

#flowContainer,
#flowContainerTwo {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  left: 0px;
  top: 0px;
  transform-origin: 50% 50%;
}

.Companyicon {
  font-size: 20px;
  color: #016ff6;
  width: 30px;
  height: 30px;
  background: #ebf2ff;
  border-radius: 4px;
  margin-right: 10px;
}

.title {
  color: #1a2332;
}

.equity-d3 {
  width: 100%;
  height: 550px;
  padding-left: 84px;
  padding-right: 76px;
  box-sizing: border-box;
}

.margin-top10 {
  margin-top: 20px !important;
}

.table-li {
  max-width: 38.5714286rem !important;
  height: 5.71428571rem;
  display: flex;
  align-items: center;
  border-top: 1px solid #cccccc;
  /* justify-content: space-around; */
}

.table-li span {
  width: 50%;
  font-size: 18px;
  line-height: 24px;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-ul {
  width: 540px !important;
  padding-left: 40px;
  margin-top: 40px;
}

.table-li-title {
  font-family: "Arial Bold";
  padding-left: 20px;
  text-align: left !important;
  background: #f2f5f9;
  justify-content: start !important;
}

.hidIcon {
  width: 28px;
  height: 26px;
}

.defaultIcon {
  width: 32px;
  height: 32px;
}

.ownTable {
  border: none;
  border-collapse: collapse;
}

.ownTable thead,
.ownTable .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.ownTable td,
.ownTable td.el-table__cell {
  min-height: 60px !important;
  height: 60px !important;
}

.ownTable .el-table__body-wrapper .el-table__row td:last-child,
.ownTable .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.ownTable::after {
  display: none !important;
}

.ownTable.el-table {
  overflow: hidden;
}

.ownTable .el-table__cell:first-child > .cell {
  padding-left: 20px !important;
}

.ownTable .el-table__body-wrapper .el-table__cell:last-child > .cell {
  padding-right: 20px !important;
}

.ownTable .el-table__header-wrapper th.el-table__cell:nth-child(6) > .cell {
  padding-right: 20px !important;
}

.el-button + .el-button {
  margin-left: 20px;
}

.graph_controls {
  position: absolute;
  top: 22px;
  right: 30px;
  z-index: 8;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 40px;
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.btn_control {
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn_control i {
  font-size: 20px;
}
.btn_control:hover {
  background-color: #f0f0f0;
  border-color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_control:active {
  background-color: #e0e0e0;
}

@media screen and (max-width: 1920px) {
  .u57fd1 {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 22px;
  }

  .u5e22d {
    font-size: 20px;
    line-height: 22px;
  }

  .u41151 {
    width: 106px;
    height: 40px;
    border-radius: 19px;
    padding: 3px;
  }

  .ub7903 {
    height: 34px;
    border-radius: 16px;
  }

  .u72482 {
    height: 34px;
    border-radius: 16px;
  }

  .uM2fl1R {
    margin-left: 30px;
    margin-top: 15px;
    margin-right: 30px;
  }

  .u144f9 {
    font-size: 15px;
  }

  .echartsBtns {
    top: 22px;
    left: 22px;
  }

  .u13926 {
    width: 24px;
    height: 24px;
    margin-left: 30px;
  }

  .u95696 {
    margin-left: 30px;
    margin-top: 7px;
  }

  .u44WfUA {
    height: 600px;
  }

  .u702a4 {
    width: 26px;
    height: 26px;
  }

  .ulDmLg9 {
    height: 600px;
    padding-top: 22px;
  }

  .trendEchartBox1 {
    width: 900px;
    height: 468px;
  }

  .gaosimohu {
    filter: blur(4px);
  }

  .echartsBtns .el-button + .el-button,
  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-top: 7px;
  }

  .el-button {
    width: 24px;
    height: 24px;
  }

  .el-icon-plus {
    font-size: 14px;
  }

  .el-icon-minus {
    font-size: 14px;
  }

  .org_tree_div {
    min-height: calc(100vh - 210px);
  }

  .org-tree-node-label-inner {
    font-size: 14px;
  }

  .content_div {
    height: 60px;
    width: 136px;
    padding: 10px 7px;
    font-size: 14px;
  }

  .content_div .title {
    margin-top: 4px;
  }

  .Ownership_img {
    top: -12px;
    left: -0.4px;
    padding: 4px 0px;
    font-size: 14px;
  }

  .Ownership_img img {
    height: 16px;
    width: 26px;
  }

  .activeOwen {
    padding: 0px 4px;
    max-height: 16px;
  }

  .personName {
    width: 60px;
    height: 60px;
    padding: 4px;
  }

  .org-tree-node-children:before {
    height: 60px;
  }

  .org-tree-node-children,
  .org-tree-node {
    padding-top: 60px;
  }

  .org-tree-node:after {
    padding-top: 45px;
  }

  .echartsBtnsTwo {
    left: 15px;
    top: 105px;
    height: 96px;
    width: 38px;
    border-radius: 18px;
    padding: 4px;
  }

  .echartsBtnsTwo-item {
    border-radius: 16px;
  }

  .Companyicon {
    font-size: 16px;
    width: 22px;
    height: 22px;
    margin-right: 7px;
  }

  .equity-d3 {
    height: 412px;
    padding-left: 64px;
    padding-right: 56px;
  }

  .margin-top10 {
    margin-top: 15px !important;
  }

  .table-li {
    max-width: 500px !important;
    height: 60px;
  }

  .table-li span {
    font-size: 16px;
    line-height: 18px;
  }

  .table-ul {
    width: 500px !important;
    padding-left: 30px;
    margin-top: 30px;
  }

  .table-li-title {
    padding-left: 15px;
  }

  .hidIcon {
    width: 22px;
    height: 20px;
  }

  .defaultIcon {
    width: 24px;
    height: 24px;
  }

  .ownTable thead,
  .ownTable .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .ownTable td,
  .ownTable td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .ownTable .el-table__cell > .cell {
    font-size: 16px;
    line-height: 22px;
  }

  .ownTable .el-table__cell:first-child > .cell {
    padding-left: 15px !important;
  }

  .ownTable .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 15px !important;
  }

  .ownTable .el-table__header-wrapper th.el-table__cell:nth-child(6) > .cell {
    padding-right: 15px !important;
  }

  .el-button + .el-button {
    margin-left: 15px;
  }

  .graph_controls {
    top: 22px;
    right: 30px;
    gap: 20px;
    width: 40px;
    padding: 20px 0;
  }

  .btn_control {
    width: 40px;
    height: 20px;
    line-height: 20px;
    font-size: 24px;
  }

  .btn_control i {
    font-size: 20px;
  }
}

@media screen and (max-width: 1439px) {
  .u57fd1 {
    padding-left: 26px;
    padding-right: 26px;
    padding-top: 20px;
  }

  .u5e22d {
    font-size: 18px;
    line-height: 20px;
  }

  .u41151 {
    width: 94px;
    border-radius: 16px;
  }

  .ub7903 {
    height: 30px;
    border-radius: 15px;
  }

  .u72482 {
    height: 30px;
    border-radius: 15px;
  }

  .uM2fl1R {
    margin-left: 26px;
    margin-top: 12px;
    margin-right: 26px;
  }

  .u144f9 {
    font-size: 14px;
  }

  .echartsBtns {
    top: 20px;
    left: 20px;
  }

  .u13926 {
    width: 22px;
    height: 22px;
    margin-left: 26px;
  }

  .u95696 {
    margin-left: 26px;
    margin-top: 6px;
  }

  .u44WfUA {
    height: 534px;
  }

  .u702a4 {
    width: 24px;
    height: 24px;
  }

  .ulDmLg9 {
    height: 534px;
    padding-top: 20px;
  }

  .trendEchartBox1 {
    width: 804px;
    height: 418px;
  }

  .gaosimohu {
    filter: blur(3px);
  }

  .echartsBtns .el-button + .el-button,
  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-top: 6px;
  }

  .el-button {
    width: 22px;
    height: 22px;
  }

  .el-icon-plus {
    font-size: 12px;
  }

  .el-icon-minus {
    font-size: 12px;
  }

  .org_tree_div {
    min-height: calc(100vh - 188px);
  }

  .org-tree-node-label-inner {
    font-size: 12px;
  }

  .content_div {
    height: 54px;
    width: 120px;
    padding: 9px 6px;
    font-size: 12px;
  }

  .content_div .title {
    margin-top: 3px;
  }

  .Ownership_img {
    top: -10px;
    left: -0.3px;
    padding: 3px 0px;
    font-size: 12px;
  }

  .Ownership_img img {
    height: 14px;
    width: 22px;
  }

  .activeOwen {
    padding: 0px 3px;
    max-height: 14px;
  }

  .personName {
    width: 54px;
    height: 54px;
    padding: 3px;
  }

  .org-tree-node-children:before {
    height: 54px;
  }

  .org-tree-node-children,
  .org-tree-node {
    padding-top: 54px;
  }

  .org-tree-node:after {
    padding-top: 40px;
  }

  .echartsBtnsTwo {
    left: 12px;
    top: 94px;
    height: 84px;
    width: 32px;
    border-radius: 16px;
    padding: 3px;
  }

  .echartsBtnsTwo-item {
    border-radius: 14px;
  }

  .Companyicon {
    font-size: 14px;
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .equity-d3 {
    height: 368px;
    padding-left: 56px;
    padding-right: 50px;
  }

  .margin-top10 {
    margin-top: 12px !important;
  }

  .table-li {
    max-width: 362px !important;
    height: 54px;
  }

  .table-li span {
    font-size: 14px;
    line-height: 16px;
  }

  .table-ul {
    width: 362px !important;
    padding-left: 26px;
    margin-top: 26px;
  }

  .table-li-title {
    padding-left: 12px;
  }

  .hidIcon {
    width: 18px;
    height: 18px;
  }

  .defaultIcon {
    width: 22px;
    height: 22px;
  }

  .ownTable thead,
  .ownTable .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .ownTable td,
  .ownTable td.el-table__cell {
    min-height: 40px !important;
    height: 40px !important;
  }

  .ownTable .el-table__cell:first-child > .cell {
    padding-left: 12px !important;
  }

  .ownTable .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 12px !important;
  }

  .ownTable .el-table__header-wrapper th.el-table__cell:nth-child(6) > .cell {
    padding-right: 12px !important;
  }

  .el-button + .el-button {
    margin-left: 12px;
  }

  .graph_controls {
    top: 20px;
    right: 26px;
  }
}
</style>
